<template>
    <div>
        <el-button type="primary"
                   @click="startTour"
                   :disabled="!tourAvailable">
            {{ $t(tourNameKey) }}
        </el-button>

        <el-tour v-model="tourStart">
            <el-tour-step v-for="step in tourSteps"
                          :key="step.id"
                          :target="step.target"
                          :title="$t(step.title)"
                          :description="$t(step.description)" />

        </el-tour>
    </div>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';

    export default defineComponent({
        props: {
            tourNameKey: {
                type: String,
                default: "helpInfo.defaultToursName",
            },
            tourSteps: {
                type: Array,
                default() {
                    return []
                }
            },
            tourAvailable: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                tourStart: false,
            };
        },
        methods: {
            async startTour() {
                await this.openCollapse()
                this.tourStart = true;
            },

            async openCollapse(){
                const element = document.getElementById("configuration-colapse");

                if(element == null){ return; }

                if(element.classList.contains("is-active")){ return; }

                // The collapse toggle is the header (a div[role="button"]), not a <button>.
                const header = element.querySelector<HTMLElement>(".el-collapse-item__header");
                if(header == null){ return; }

                header.click();

                // is-active is added at the start of the expand animation, so wait for
                // the transition to finish before the tour measures the target.
                await this.waitForExpand(element);
            },

            waitForExpand(element: HTMLElement){
                return new Promise<void>((resolve) => {
                    const wrap = element.querySelector(".el-collapse-item__wrap");
                    if(wrap == null){ resolve(); return; }

                    let done = false;
                    const finish = () => {
                        if(done){ return; }
                        done = true;
                        wrap.removeEventListener("transitionend", finish);
                        resolve();
                    };

                    wrap.addEventListener("transitionend", finish);
                    // Fallback in case the transition is skipped (e.g. reduced motion).
                    setTimeout(finish, 400);
                });
            }

        }
    })
</script>